<template>
  <div ref="paganiniplus" class="paganiniplus">
    <div class="wrapper" @click="onClick">
      <div v-if="sizeBox.large" class="wrapper-large">
        <div class="pgnnp_ads" style="width: 970px; height: 90px; border: 1px solid #ececec;" />
      </div>
      <div v-if="sizeBox.medium" class="wrapper-medium">
        <div class="pgnnp_ads" style="width: 728px; height: 90px; border: 1px solid #ececec;" />
      </div>
      <div v-if="sizeBox.small" class="wrapper-small">
        <div class="pgnnp_ads" style="width: 468px; height: 60px; border: 1px solid #ececec;" />
      </div>
      <div v-if="sizeBox.extraSmall" class="wrapper-extra-small">
        <div class="pgnnp_ads" style="width: 320px; height: 50px; border: 1px solid #ececec;" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Paganiniplus',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      sizeBox: {
        large: false,
        midium: false,
        small: false
      },
      debounceTimer: 0,
      clientWidth: 0 // init
    }
  },
  computed: {},
  watch: {
    clientWidth(newValue) {
      if (newValue >= (1024 + 72)) {
        this.sizeBox = { large: true, medium: false, small: false, extraSmall: false }
      } else if (newValue > (728 + 48) && newValue < (1024 + 72)) {
        this.sizeBox = { large: false, medium: true, small: false, extraSmall: false }
      } else if (newValue > (468 + 48) && newValue < (728 + 48)) {
        this.sizeBox = { large: false, medium: false, small: true, extraSmall: false }
      } else {
        this.sizeBox = { large: false, medium: false, small: false, extraSmall: true }
      }
    }
  },
  created() {},
  updated() {},
  mounted() {
    window.addEventListener('resize', this.debounceGetClientWidth)
    this.$nextTick(() => {
      this.getClientWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debounceGetClientWidth)
  },
  methods: {
    getClientWidth() {
      this.clientWidth = this.$refs.paganiniplus && this.$refs.paganiniplus.clientWidth
    },
    debounceGetClientWidth() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.getClientWidth()
      }, 60)
    },
    onClick() {
      // console.log('on click')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.paganiniplus {
  width: 100%;
  margin: 0 auto;
  .wrapper {
    text-align: center;
    .wrapper-large,
    .wrapper-medium,
    .wrapper-small,
    .wrapper-extra-small {
      display: inline-block; // for align center
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
@media only screen and (max-width: 368.98px) {
  // Csustomized, spacial case
  .paganiniplus {
    width: 320px;
    margin: 0 calc((100vw - 320px) / 2); // align middle
  }
}
</style>
